export default __webpack_public_path__ + "static/media/ruinouspower.693a3805.png";